module.exports = __webpack_public_path__ + "c2e870f6617a4d270ed2205ccf6bbd19.png";